import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Face from "@/model/face";
import faceApi from "@/api/faceApi";
import UnitName from "@/model/unitName";
import Repair from "@/model/repair";
import MasterDirection from "@/model/masterDirection";
import unitNameApi from "@/api/unitNameApi";
import repairApi from "@/api/repairApi";
import masterDirectionApi from "@/api/masterDirectionApi";

@Module({ namespaced: true })
export default class MasterModule extends VuexModule {
  public faces: Face[] = null;
  public units: UnitName[] = null;
  public repairs: Repair[] = null;
  public directions: MasterDirection[] = null;
  @Mutation
  setData(data: any): void {
    this.faces = data.faces;
    this.units = data.units;
    this.repairs = data.repairs;
    this.directions = data.directions;
  }

  @Action({ rawError: true })
  async fetchAll(): Promise<any> {
    const query = {
      status: 1
    };
    const request = [
      faceApi.index(query),
      unitNameApi.index(),
      repairApi.index(query),
      masterDirectionApi.index(),
    ]

    const result = await Promise.all(request);
    if (result) {
      const data = {
        faces: result[0],
        units: result[1],
        repairs: result[2],
        directions: result[3],
      };
      this.context.commit("setData", data);
    }
  }

  get getFaces(): Face[] {
    return this.faces;
  }
  get getUnits(): UnitName[] {
    return this.units;
  }
  get getRepairs(): Repair[] {
    return this.repairs;
  }
  get getDirections(): MasterDirection[] {
    return this.directions;
  }
}
